import type { ApolloClient } from '@apollo/client/core';
import { Injectable, OnDestroy } from '@angular/core';
import { DocumentNode, Kind, visit } from 'graphql';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GraphQLData } from './common/graphql.data';

@Injectable()
export class GraphQLMutate extends GraphQLData implements OnDestroy {
	mutate<T>(doc?: DocumentNode, opts?: Partial<ApolloClient.MutateOptions<T>>): Observable<T> {
		return this.apollo
			.mutate<T>({
				mutation: filterize(doc ?? this.command),
				variables: this.vars,
				...opts,
			})
			.pipe(
				map((response) => response.data),
				catchError((e) => this.handleError(e)),
			);
	}
}

function filterize(document: DocumentNode): DocumentNode {
	return visit(document, {
		Field(node, _key, _parent, _path, ancestors) {
			const isRootMutation = ancestors.some((a) => (a as any).kind === Kind.OPERATION_DEFINITION && (a as any).operation === 'mutation') && !ancestors.some((a) => (a as any).kind === Kind.FIELD);

			// Only add accountId on root objects
			if (!isRootMutation) {
				return undefined;
			}

			const selections = node.selectionSet?.selections ?? [];

			// If the accountId property is already added to the mutation, simply return
			if (selections.some((sel) => sel.kind === Kind.FIELD && sel.name.value === 'accountId')) {
				return undefined;
			}

			// Merge the accountId property onto the mutation schema
			return {
				...node,
				selectionSet: {
					kind: Kind.SELECTION_SET,
					selections: [...selections, { kind: Kind.FIELD, name: { kind: Kind.NAME, value: 'accountId' } }],
				},
			};
		},
	});
}
